/* eslint-disable func-names */
import { GKTypography, Show } from "components";
import GKCharts from "components/GKCharts";
import { useEffect, useState } from "react";
import { numberToCurrency } from "utils/MathFunction";

const PortfolioChart = ({ data, loading }: any) => {
  const [hoverData, setHoverData] = useState<any>();

  const chartOptions = {
    title: {
      text: ` `,
      align: "center",
      verticalAlign: "middle",
      style: {
        fontSize: "1.1em",
      },
    },
    chart: {
      height: 220,
      width: 335,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
        },
        point: {
          events: {
            mouseOut: function () {
              setHoverData({
                name: "Total Gain",
                y: data?.totalReturns,
              });
            },
            mouseOver: function (this) {
              setHoverData(this);
            },
          },
        },
        startAngle: -90,
        endAngle: 90,
        center: ["50%", "100%"],
        size: "190%",
        borderRadius: 6,
      },
      series: {
        states: {
          hover: {
            enabled: false,
          },
        },
        animation: false,
      },
    },
    colors: ["#39627A", "#709D88", "#FCAA67"],
    tooltip: {
      enabled: false,
    },
    series: [
      {
        type: "pie",
        name: " ",
        innerSize: "75%",
        data: [
          ["Unrealised Gain", data?.unrealisedGain],
          ["Realised Gain", data?.realisedGain],
          ["Dividend", data?.dividend],
        ],
      },
    ],
  };

  useEffect(() => {
    setHoverData({
      name: "Total Gain",
      y: data?.totalReturns,
    });
  }, [data]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <Show.When isTrue={hoverData}>
        <div
          style={{
            position: "absolute",
            bottom: 40,
            zIndex: 1,
          }}
        >
          <GKTypography color={"#697586 "} fontSize={14} textAlign={"center"}>
            {hoverData?.name}
          </GKTypography>
          <GKTypography
            fontWeight={600}
            fontSize={18}
            textAlign={"center"}
            loading={loading}
          >
            {numberToCurrency(hoverData?.y || 0)}
          </GKTypography>
        </div>
      </Show.When>
      <GKCharts chartOptions={chartOptions} loading={loading} />
    </div>
  );
};

export default PortfolioChart;
